import { render, staticRenderFns } from "./ProcedureFileDocument.vue?vue&type=template&id=735f19fe&"
import script from "./ProcedureFileDocument.vue?vue&type=script&lang=js&"
export * from "./ProcedureFileDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports